var _rect, _path, _path2, _line, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeWithCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.9945 12.2677C4.8572 12.1204 4.74172 11.9905 4.64989 11.8844C4.74172 11.7783 4.8572 11.6485 4.9945 11.5012C5.3871 11.0798 5.95509 10.5182 6.65557 9.95759C8.06964 8.82591 9.95908 7.75 12 7.75C14.0409 7.75 15.9304 8.82591 17.3444 9.95759C18.0449 10.5182 18.6129 11.0798 19.0055 11.5012C19.1428 11.6485 19.2583 11.7783 19.3501 11.8844C19.2583 11.9906 19.1428 12.1204 19.0055 12.2677C18.6129 12.6891 18.0449 13.2507 17.3444 13.8113C15.9304 14.943 14.0409 16.0189 12 16.0189C9.95908 16.0189 8.06964 14.943 6.65557 13.8113C5.95509 13.2507 5.3871 12.6891 4.9945 12.2677Z",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 11.8842C14.75 13.2643 13.537 14.4148 12 14.4148C10.463 14.4148 9.25 13.2643 9.25 11.8842C9.25 10.5041 10.463 9.35352 12 9.35352C13.537 9.35352 14.75 10.5041 14.75 11.8842Z",
  stroke: "currentColor",
  strokeWidth: 0.5
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  y1: -0.5,
  x2: 17.8838,
  y2: -0.5,
  transform: "matrix(0.726916 -0.686726 0.739827 0.672797 6 18.1406)",
  stroke: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5,
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeWithCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/eyeWithCircle.7a1d353257d092d1e33fdd2d33fa0a7b.svg";